<template>
    <div class="language-programs">
        <v-btn 
            icon 
            class="language-programs-close"
            @click="close">
            <v-icon>mdi-close</v-icon>
        </v-btn>

        <h3 class="language-programs-title">¿Cuál curso te interesa?</h3>
        <div class="language-programs-subtitle">
            Tu respuesta es solo referencial
        </div>

        <div 
            class="language-programs-item" 
            v-for="(p, index) in items"
            :key="index"
            >
            <div class="lng-icon-cont" @click="select(p)">
                <img src="@/assets/images/flags/check_on.svg" v-if="selectedProgram && selectedProgram.id == p.id">
                <img src="@/assets/images/flags/check.svg" v-else>
            </div>
            <div class="language-programs-item-name" @click="select(p)">
                {{ p.name }}
            </div>
            <div class="ver-mas" @click="mas(p)">
                Ver Más
            </div>
        </div>
        <div class="language-programs-footer">
            <v-btn
                color="primary"
                class="btn-basic uppercase"
                v-if="selectedProgram"
                @click="toContinue()"
                :loading="loading"
                >
                Continuar
            </v-btn>
        </div>
    </div>
</template>
<script>
export default {
    props:['items'],
    data() {
        return {
            selectedProgram: null,
            loading: false
        }
    },
    methods: {
        toContinue(){
            this.loading = true;
            this.$emit('next');
        },
        close() {
            this.selectedProgram = null;
            this.$emit('selected',this.selectedProgram);
            this.$emit('close');
        },
        select(p){
            if(this.selectedProgram){
                if(this.selectedProgram.id != p.id) {
                    this.selectedProgram = p;
                } else {
                    this.selectedProgram = null;
                }
            } else {
                this.selectedProgram = p;
            }
            
            this.$emit('selected',this.selectedProgram);
        },
        mas(p){
            this.$emit('pup',p);
        }
    }
}
</script>